<template>
  <v-app>
    <page-header/>
    <main>
      <v-container fluid>
        <router-view/>
        <v-snackbar
          :timeout=6000
          :color="color"
          :multi-line="'multi-line'"
          v-model="snackbar">
          <v-icon dark>error_outline</v-icon>
          {{ error }}
          <v-btn dark flat @click.native="snackbar = false">Cerrar</v-btn>
        </v-snackbar>
      </v-container>
    </main>
  </v-app>
</template>

<script>
import PageHeader from '@/components/Header.vue'
export default {
  name: 'App',
  data () {
    return {
      error: null,
      snackbar: false,
      color: ''
    }
  },
  components: {
    PageHeader
  },
  created () {
    this.$store.watch(this.$store.getters.getError, (n) => {
      if (n === 'Sesión expirada') {
        this.error = n
        this.snackbar = true
        this.color = 'error'
      }
    })
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 48px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue